'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cyrillicLettersAndMarks = require('./cyrillicLettersAndMarks');

var _cyrillicLettersAndMarks2 = _interopRequireDefault(_cyrillicLettersAndMarks);

var _latinAccentChars = require('./latinAccentChars');

var _latinAccentChars2 = _interopRequireDefault(_latinAccentChars);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validGeneralUrlPathChars = (0, _regexSupplant2.default)(/[a-z#{cyrillicLettersAndMarks}0-9!\*';:=\+,\.\$\/%#\[\]\-\u2013_~@\|&#{latinAccentChars}]/i, { cyrillicLettersAndMarks: _cyrillicLettersAndMarks2.default, latinAccentChars: _latinAccentChars2.default }); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = validGeneralUrlPathChars;
module.exports = exports['default'];